import { createBrowserRouter, Navigate } from 'react-router-dom';

import { Layout } from '@/components/Layout/Layout';
import { Login } from '@/pages/Login';
import { useAuth } from '@/store/useAuth';
import { Alerts } from '@/pages/Alerts';
import { Articles } from '@/pages/Articles';
import { ArticleEditor } from '@/pages/ArticleEditor';
import { AuditPanel } from '@/pages/AuditPanel';
import { Config } from '@/pages/Config';
import { ConfigAiProviders } from '@/pages/ConfigAiProviders';
import { ConfigCredenciais } from '@/pages/ConfigCredenciais';
import { ConfigCustos } from '@/pages/ConfigCustos';
import { ConfigExternalApis } from '@/pages/ConfigExternalApis';
import { ConfigHoroscopo } from '@/pages/ConfigHoroscopo';
import { ConfigQuentes } from '@/pages/ConfigQuentes';
import { ConfigMarca } from '@/pages/ConfigMarca';
import { ConfigSites } from '@/pages/ConfigSites';
import { Dashboard } from '@/pages/Dashboard';
import { ExecutionDetail } from '@/pages/ExecutionDetail';
import { Horoscopo } from '@/pages/Horoscopo';
import { NCNews } from '@/pages/NCNews';
import { Notifications } from '@/pages/Notifications';
import { Prompts } from '@/pages/Prompts';
import { Stories } from '@/pages/Stories';
import { StoryDetail } from '@/pages/StoryDetail';
import { TemplateEditor } from '@/pages/TemplateEditor';
import { Twitter } from '@/pages/Twitter';
import { WorkflowDetail } from '@/pages/WorkflowDetail';
import { WorkflowOverride } from '@/pages/WorkflowOverride';
import { Workflows } from '@/pages/Workflows';
import { Intelligence } from '@/pages/Intelligence';
import { Board } from '@/pages/Board';
import { Editorias } from '@/pages/Editorias';
import { Engineering } from '@/pages/Engineering';
import { Cidades } from '@/pages/Cidades';
import { Mapa } from '@/pages/Mapa';
import { TrocarSenha } from '@/pages/TrocarSenha';
import { ConfigUsuarios } from '@/pages/ConfigUsuarios';
import { FeedDrive } from '@/pages/FeedDrive';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const token = useAuth((s) => s.token);
  const mustChange = useAuth((s) => s.mustChange);
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (mustChange) {
    return <Navigate to="/trocar-senha" replace />;
  }
  return <>{children}</>;
}

function RequireToken({ children }: { children: React.ReactNode }) {
  const token = useAuth((s) => s.token);
  return token ? <>{children}</> : <Navigate to="/login" replace />;
}

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/trocar-senha', element: <RequireToken><TrocarSenha /></RequireToken> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/inteligencia" replace /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'inteligencia', element: <Intelligence /> },
      { path: 'inteligencia/feeddrive', element: <FeedDrive /> },
      { path: 'producao', element: <Board /> },
      { path: 'engineering', element: <Engineering /> },
      { path: 'editorias', element: <Editorias /> },
      { path: 'cidades', element: <Cidades /> },
      { path: 'mapa', element: <Mapa /> },
      { path: 'stories', element: <Stories /> },
      { path: 'stories/:id', element: <StoryDetail /> },
      { path: 'artigos', element: <Articles /> },
      { path: 'artigos/:id', element: <ArticleEditor /> },
      { path: 'workflows', element: <Workflows /> },
      { path: 'workflows/:id', element: <WorkflowDetail /> },
      { path: 'workflows/:id/override', element: <WorkflowOverride /> },
      { path: 'workflows/:id/execucoes/:execId', element: <ExecutionDetail /> },
      { path: 'horoscopo', element: <Horoscopo /> },
      { path: 'ncnews', element: <NCNews /> },
      { path: 'twitter', element: <Twitter /> },
      { path: 'config', element: <Config /> },
      { path: 'config/sites', element: <ConfigSites /> },
      { path: 'config/ai-providers', element: <ConfigAiProviders /> },
      { path: 'config/external-apis', element: <ConfigExternalApis /> },
      { path: 'config/quentes', element: <ConfigQuentes /> },
      { path: 'config/usuarios', element: <ConfigUsuarios /> },
      { path: 'config/marca', element: <ConfigMarca /> },
      { path: 'config/horoscopo', element: <ConfigHoroscopo /> },
      { path: 'config/credenciais', element: <ConfigCredenciais /> },
      { path: 'config/custos', element: <ConfigCustos /> },
      { path: 'config/prompts', element: <Prompts /> },
      { path: 'config/prompts/:id', element: <TemplateEditor /> },
      { path: 'config/notificacoes', element: <Notifications /> },
      { path: 'config/audit', element: <AuditPanel /> },
      { path: 'alertas', element: <Alerts /> },
    ],
  },
]);
